import { storeTestimonials } from "./storeTestimonialsData";

export const testimonialsData = {
  heading: {
    topText: "Clients Talking",
    titleText: "What partners say",
    coloredText: "after go-live.",
    description:
      "Verified reviews from founders and product leaders — the people who signed the PO and stayed with us past launch.",
  },
  items: [
    {
      id: "t.01",
      rating: 5,
      quote:
        "VelanApps have end-to-end capability, which differentiates them from other IT services companies. They provided custom software development, completed a full cloud migration to AWS, instituted QA automation, and performed post-launch support — all under a single, 10-month engagement with no need to juggle multiple vendors. Their members communicated clearly, are technically absolutely knowledgeable, and always delivered on time. We have renewed our contract thrice, and we still depend on their service.",
      result:
        "3× Contract extensions from VelanApps for 10 months of continuous delivery",
      author: {
        name: "Marcus Webb",
        role: "Full-Time Client",
        company: "Miami, FL, USA",
      },
    },
    {
      id: "t.02",
      rating: 5,
      quote:
        "We wanted to create an AI-powered mobile app that could analyse live inventory data and recommend tailored product bundles. VelanApps emerged as one of the very few companies with an actual command over AI-powered mobile app development. They built a powerful ML pipeline, wrote Swift/Kotlin native layers, and integrated our recommendation engine seamlessly. The app is now reactive to each user's shopping behaviour in real time, providing an extremely bespoke experience.",
      result: "38% boost in average order value within Quarter 1 of the launch",
      author: {
        name: "Nathan Clarke",
        role: "Founder",
        company: "Phoenix, AZ, North America",
      },
    },
    {
      id: "t.03",
      rating: 5,
      quote:
        "While searching various software outsourcing companies, VelanApps stood out due to their transparent and systematic development process. We had highly detailed sprint reports every 2 weeks, weekly calls for constant communication, and a project manager dedicated to our project who had a solid understanding of our product vision.",
      result:
        "Launched our SaaS platform in 18 weeks — 22% under anticipated spend",
      author: {
        name: "Kevin Harrington",
        role: "VP Product",
        company: "Streamline SaaS Company · Atlanta, USA",
      },
    },
    {
      id: "t.04",
      rating: 5,
      quote:
        "We had outgrown our website six times over and needed a full reimagination of our digital footprint. VelanApps delivered end-to-end website development services — strategy, UX design, custom WordPress development, CRM integration, and SEO architecture. Their consultative approach stood out; the team first sought to understand our business goals before writing a single line of code.",
      result:
        "47% rise in leads from organic sources in 90 days. Bounce rate dropped from 74% to 38%",
      author: {
        name: "Thomas Gallagher",
        role: "Director of Marketing",
        company: "Denver, CO, USA",
      },
    },
  ],
};

export const laravelTestimonialsData = {
  heading: {
    topText: "Clients Talking",
    titleText: "What partners say",
    coloredText: "after go-live.",
    description:
      "Verified reviews from founders and product leaders — the people who signed the PO and stayed with us past launch.",
  },
  items: [
    {
      id: "t.01",
      rating: 5,
      quote:
        "Velan’s Laravel developers brought strong technical expertise to our project and quickly adapted to our development environment. Their ability to deliver scalable and reliable solutions helped us accelerate our product development.",
      result:
        "3× Contract extensions from VelanApps for 10 months of continuous delivery",
      author: {
        name: "Christopher Bennett",
        role: "Chief Technology Officer",
        company: "",
      },
    },
    {
      id: "t.02",
      rating: 5,
      quote:
        "The Laravel development team was professional, responsive, and easy to work with. They understood our requirements well and consistently delivered high-quality work within our project timelines.",
      result: "38% boost in average order value within Quarter 1 of the launch",
      author: {
        name: "Amanda Foster",
        role: "Head of Product",
        company: "",
      },
    },
    {
      id: "t.03",
      rating: 5,
      quote:
        "We were impressed by the technical skills and flexibility of Velan’s Laravel developers. They handled complex requirements efficiently and worked closely with our team to keep development moving smoothly.",
      result:
        "Launched our SaaS platform in 18 weeks — 22% under anticipated spend",
      author: {
        name: "Brandon Hayes",
        role: "Engineering Manager",
        company: "",
      },
    },
  ],
};

export const MagentoTestimonialsData = {
  heading: {
    topText: "Clients Talking",
    titleText: "What partners say",
    coloredText: "after go-live.",
    description:
      "Verified reviews from founders and product leaders — the people who signed the PO and stayed with us past launch.",
  },
  items: [
    {
      id: "t.01",
      rating: 5,
      quote:
        "Our Magento store had accumulated years of customizations, extensions, and technical debt. Velan’s developers took the time to understand the existing setup before making changes. They cleaned up critical issues, improved site stability, and helped us move forward without rebuilding everything from scratch.",
      result:
        "3× Contract extensions from VelanApps for 10 months of continuous delivery",
      author: {
        name: "Christopher Hayes",
        role: "Director of eCommerce",
        company: "",
      },
    },
    {
      id: "t.02",
      rating: 5,
      quote:
        "We needed Magento developers who could go beyond standard implementations. Velan helped us build custom functionality and connect Magento with our existing business systems. What stood out was their ability to understand the business requirement behind each technical request rather than simply writing code.",
      author: {
        name: "Lauren Bennett",
        role: "Digital Commerce Manager",
        company: "",
      },
    },
    {
      id: "t.03",
      rating: 5,
      quote:
        "Our priority was creating a Magento store that could handle increasing traffic, products, and orders as we grew. Velan’s developers focused on performance, scalability, and a cleaner architecture from the beginning. The result was a platform that gave our team much more confidence in scaling the business.",
      result:
        "Launched our SaaS platform in 18 weeks — 22% under anticipated spend",
      author: {
        name: "Ryan Mitchell",
        role: "VP of Technology",
        company: "",
      },
    },
  ],
};

export const wordpresscmsdevelopmenttestimonialsData = {
  heading: {
    topText: "Clients Talking",
    titleText: "What partners say",
    coloredText: "after go-live.",
    description:
      "Verified reviews from founders and product leaders — the people who signed the PO and stayed with us past launch.",
  },
  items: [
    {
      id: "t.01",
      rating: 5,
      quote:
        "VelanApps turned our WordPress environment into a much more structured and scalable CMS. The custom workflows and integrations have significantly simplified how our teams manage and publish content.",
      result: "",
      author: {
        name: "Ethan Caldwell",
        role: "VP of Digital Experience",
        company: "",
      },
    },
    {
      id: "t.02",
      rating: 5,
      quote:
        "We needed a CMS that could support both our content and growing digital operations. VelanApps delivered a flexible WordPress solution that gave our team better control without adding unnecessary complexity.",
      author: {
        name: "Madison Brooks",
        role: "Head of E-commerce",
        company: "",
      },
    },
    {
      id: "t.03",
      rating: 5,
      quote:
        "VelanApps approached our CMS requirements with a strong focus on architecture, performance, and long-term scalability. The resulting platform is easier for our teams to manage and ready for future enhancements.",
      result: "",
      author: {
        name: "Nathaniel Foster",
        role: "Director of Technology",
        company: "",
      },
    },
  ],
};

export const fullStackTestimonialsData = {
  heading: {
    topText: "Clients Talking",
    titleText: "What partners say",
    coloredText: "after go-live.",
    description:
      "Verified reviews from founders and product leaders — the people who signed the PO and stayed with us past launch.",
  },

  items: [
    {
      id: "t.01",
      rating: 5,
      quote:
        "Velan’s full-stack developers became a natural extension of our product team. They handled everything from frontend improvements to backend architecture and integrations, helping us move from development to launch with confidence.",
      result: "",
      author: {
        name: "Michael Reynolds",
        role: "Head of Product",
        company: "",
      },
    },

    {
      id: "t.02",
      rating: 5,
      quote:
        "What stood out was Velan’s ability to solve problems beyond the code. Their developers understood our workflows, suggested practical improvements, and delivered a scalable application that was easy for our team to maintain.",
      result: "",
      author: {
        name: "Sarah Whitmore",
        role: "Technology Manager",
        company: "",
      },
    },

    {
      id: "t.03",
      rating: 5,
      quote:
        "We needed experienced developers who could take ownership of both frontend and backend work. Velan delivered exactly that, with strong technical communication, dependable delivery, and a clear focus on application performance.",
      result: "",
      author: {
        name: "Christopher Hayes",
        role: "Engineering Manager",
        company: "",
      },
    },
  ],
};

export const MVPServiceTestimonialsData = {
  heading: {
    topText: "Founder Reviews",
    titleText: "What founders say",
    coloredText: "after launch.",
    description:
      "Verified reviews from founders who shipped their MVP with VelanApps and went on to raise funding.",
  },
  items: [
    {
      id: "mvp.01",
      rating: 5,
      quote:
        "Velan Apps' custom MVP software development turned our concept into a working platform in under seven weeks",
      result: "We closed our seeds round two months later. ($1.2M seed)",
      author: {
        name: "Sona Rao",
        role: "Founder",
        company: "HealthStack",
      },
    },
    {
      id: "mvp.02",
      rating: 5,
      quote:
        "We spoke to five MVP development companies before Velan Apps. The difference was instant — they pushed back on features that did not matter and protected our runway.",
      result: "Series A",
      author: {
        name: "James Thornton",
        role: "Co-founder",
        company: "FreightOS",
      },
    },
    {
      id: "mvp.03",
      rating: 5,
      quote:
        "The MVP app development process was genuinely transparent: working software every week and code quality our CTO admired.",
      result: "10k users in 90 days",
      author: {
        name: "Mirel Kovacs",
        role: "CEO",
        company: "LogiSense",
      },
    },
    ...testimonialsData.items,
  ],
};

export const SaaSTestimonialsData = {
  heading: {
    topText: "SaaS Reviews",
    titleText: "What SaaS teams say",
    coloredText: "after shipping.",
    description:
      "Verified reviews from product leaders who built and scaled their SaaS platform with VelanApps.",
  },
  items: [
    {
      id: "mvp.01",
      rating: 5,
      quote:
        "Velan Apps' custom MVP software development turned our concept into a working platform in under seven weeks",
      result: "We closed our seeds round two months later. ($1.2M seed)",
      author: {
        name: "Sona Rao",
        role: "Founder",
        company: "HealthStack",
      },
    },
    {
      id: "mvp.02",
      rating: 5,
      quote:
        "We spoke to five MVP development companies before Velan Apps. The difference was instant — they pushed back on features that did not matter and protected our runway.",
      result: "Series A",
      author: {
        name: "James Thornton",
        role: "Co-founder",
        company: "FreightOS",
      },
    },
    {
      id: "mvp.03",
      rating: 5,
      quote:
        "The MVP app development process was genuinely transparent: working software every week and code quality our CTO admired.",
      result: "10k users in 90 days",
      author: {
        name: "Mirel Kovacs",
        role: "CEO",
        company: "LogiSense",
      },
    },
    ...testimonialsData.items,
  ],
};

export const LegacyTestimonialsData = {
  heading: {
    topText: "Client Reviews",
    titleText: "What teams say",
    coloredText: "after modernising.",
    description:
      "Verified reviews from technology leaders who modernised their legacy systems with VelanApps.",
  },
  items: [
    {
      id: "mvp.01",
      rating: 5,
      quote:
        "Velan Apps' custom MVP software development turned our concept into a working platform in under seven weeks",
      result: "We closed our seeds round two months later. ($1.2M seed)",
      author: {
        name: "Sona Rao",
        role: "Founder",
        company: "HealthStack",
      },
    },
    {
      id: "mvp.02",
      rating: 5,
      quote:
        "We spoke to five MVP development companies before Velan Apps. The difference was instant — they pushed back on features that did not matter and protected our runway.",
      result: "Series A",
      author: {
        name: "James Thornton",
        role: "Co-founder",
        company: "FreightOS",
      },
    },
    {
      id: "mvp.03",
      rating: 5,
      quote:
        "The MVP app development process was genuinely transparent: working software every week and code quality our CTO admired.",
      result: "10k users in 90 days",
      author: {
        name: "Mirel Kovacs",
        role: "CEO",
        company: "LogiSense",
      },
    },
    ...testimonialsData.items,
  ],
};

export const EnterpriseTestimonialsData = {
  heading: {
    topText: "Enterprise Reviews",
    titleText: "Trusted by",
    coloredText: "Global Enterprises",
    description: null,
  },
  items: [
    {
      id: "enterprise.01",
      rating: 5,
      quote:
        "Velan Apps refactored our core platform into microservices in less than a day with no downtime. They delivered exactly what was scoped and significantly improved system reliability.",
      result: "99.95% Platform Uptime",
      author: {
        name: "Rachel Morgan",
        role: "Chief Information Officer",
        company: "Nexus Enterprises",
      },
    },
    {
      id: "enterprise.02",
      rating: 5,
      quote:
        "A trusted software development partner—security-first, transparent, and consistently on schedule throughout our 18-month transformation program.",
      result: "30% Reduction in Operating Costs",
      author: {
        name: "David Walker",
        role: "VP of Engineering",
        company: "ScaleOps Technologies",
      },
    },
    {
      id: "enterprise.03",
      rating: 5,
      quote:
        "They modernized our decade-old enterprise platform and reduced release cycles from months to days.",
      result: "75% Faster Release Cycles",
      author: {
        name: "Arjun Mehta",
        role: "Director of Digital Transformation",
        company: "Vertex Manufacturing Group",
      },
    },
    {
      id: "enterprise.04",
      rating: 5,
      quote:
        "Their AI integration delivered measurable business value and actionable insights. We've expanded the engagement twice since launch.",
      result: "45% Faster Decision-Making with AI Insights",
      author: {
        name: "Priya Nair",
        role: "Head of Enterprise Applications",
        company: "FinEdge Solutions",
      },
    },

    ...testimonialsData.items,
  ],
};

export const ApiDevelopmentTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our API",
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "api.01",
      rating: 5,
      quote:
        "Velan Apps demystified a decade of point-to-point integrations and provided us with a single clean API layer. Our teams are finally confident in the information.",
      result: "60% Reduction in Integration Complexity",
      author: {
        name: "James Whitfield",
        role: "Chief Technology Officer",
        company: "Meridian FinTech",
      },
    },
    {
      id: "api.02",
      rating: 5,
      quote:
        "They integrated our CRM, ERP, and payment stack within weeks with webhooks that simply work. Manual reconciliation is completely eliminated.",
      result: "100% Elimination of Manual Reconciliation",
      author: {
        name: "Sofia Ramos",
        role: "Head of Technology",
        company: "Orbit Commerce Group",
      },
    },
    {
      id: "api.03",
      rating: 5,
      quote:
        "Following their remodelling efforts, the average response time declined considerably and error rates dropped across the entire company.",
      result: "40% Faster API Response Times",
      author: {
        name: "Nathan Clarke",
        role: "Engineering Manager",
        company: "Pulse SaaS Solutions",
      },
    },
    {
      id: "api.04",
      rating: 5,
      quote:
        "A genuine engineering partner — security-first, well-documented, and on time. We've scaled three more integrations with them since launch.",
      result: "3× Integrations Scaled Post-Launch",
      author: {
        name: "Ananya Krishnan",
        role: "VP of Engineering",
        company: "Stratex Enterprises",
      },
    },

    ...testimonialsData.items,
  ],
};

export const RestApiDevelopmentTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our REST API",
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "rest.01",
      rating: 5,
      quote:
        "Velan Apps transformed a mess of old endpoints into a well-documented REST layer. Our integrations now work predictably — something we hadn't experienced in years.",
      result: "100% Predictable Integration Performance",
      author: {
        name: "Richard Hawes",
        role: "VP of Engineering",
        company: "CoreBridge Systems",
      },
    },
    {
      id: "rest.02",
      rating: 5,
      quote:
        "They built our public REST API and SDKs from the ground up. Partner onboarding that previously took weeks now takes a single day.",
      result: "Partner Onboarding Reduced from Weeks to 1 Day",
      author: {
        name: "Leila Fontaine",
        role: "Head of Platform",
        company: "Nexio SaaS",
      },
    },
    {
      id: "rest.03",
      rating: 5,
      quote:
        "Our CRM, billing, and analytics are now connected through a single REST API with webhooks. Manual data entry between systems is completely gone.",
      result: "Zero Manual Data Entry Across 3 Core Systems",
      author: {
        name: "Daniel Osei",
        role: "Director of Operations",
        company: "Vantage Commerce",
      },
    },

    ...testimonialsData.items,
  ],
};

export const WebDevelopmentTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our Web",
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "rest.01",
      rating: 5,
      quote:
        "Velan Apps transformed a mess of old endpoints into a well-documented REST layer. Our integrations now work predictably — something we hadn't experienced in years.",
      result: "100% Predictable Integration Performance",
      author: {
        name: "Richard Hawes",
        role: "VP of Engineering",
        company: "CoreBridge Systems",
      },
    },
    {
      id: "rest.02",
      rating: 5,
      quote:
        "They built our public REST API and SDKs from the ground up. Partner onboarding that previously took weeks now takes a single day.",
      result: "Partner Onboarding Reduced from Weeks to 1 Day",
      author: {
        name: "Leila Fontaine",
        role: "Head of Platform",
        company: "Nexio SaaS",
      },
    },
    {
      id: "rest.03",
      rating: 5,
      quote:
        "Our CRM, billing, and analytics are now connected through a single REST API with webhooks. Manual data entry between systems is completely gone.",
      result: "Zero Manual Data Entry Across 3 Core Systems",
      author: {
        name: "Daniel Osei",
        role: "Director of Operations",
        company: "Vantage Commerce",
      },
    },

    ...testimonialsData.items,
  ],
};

export const ApplicationDevelopmentTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our Application",
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "rest.01",
      rating: 5,
      quote:
        "Velan Apps transformed a mess of old endpoints into a well-documented REST layer. Our integrations now work predictably — something we hadn't experienced in years.",
      result: "100% Predictable Integration Performance",
      author: {
        name: "Richard Hawes",
        role: "VP of Engineering",
        company: "CoreBridge Systems",
      },
    },
    {
      id: "rest.02",
      rating: 5,
      quote:
        "They built our public REST API and SDKs from the ground up. Partner onboarding that previously took weeks now takes a single day.",
      result: "Partner Onboarding Reduced from Weeks to 1 Day",
      author: {
        name: "Leila Fontaine",
        role: "Head of Platform",
        company: "Nexio SaaS",
      },
    },
    {
      id: "rest.03",
      rating: 5,
      quote:
        "Our CRM, billing, and analytics are now connected through a single REST API with webhooks. Manual data entry between systems is completely gone.",
      result: "Zero Manual Data Entry Across 3 Core Systems",
      author: {
        name: "Daniel Osei",
        role: "Director of Operations",
        company: "Vantage Commerce",
      },
    },

    ...testimonialsData.items,
  ],
};

export const clientReviewsTestimonialsData = {
  featured: {
    id: "t.01",
    rating: 5,
    quote:
      "VelanApps have end-to-end capability, which differentiates them from other IT services companies. They provided custom software development, completed a full cloud migration to AWS, instituted QA automation, and performed post-launch support — all under a single, 10-month engagement with no need to juggle multiple vendors. Their members communicated clearly, are technically absolutely knowledgeable, and always delivered on time. We have renewed our contract thrice, and we still depend on their service.",
    result:
      "3× Contract extensions from VelanApps for 10 months of continuous delivery",
    author: {
      name: "Marcus Webb",
      role: "Full-Time Client",
      company: "Miami, FL, USA",
    },
  },
  items: [
    {
      id: "t.02",
      rating: 5,
      quote:
        "We wanted to create an AI-powered mobile app that could analyse live inventory data and recommend tailored product bundles. VelanApps emerged as one of the very few companies with an actual command over AI-powered mobile app development.",
      result: "38% boost in average order value within Quarter 1 of the launch",
      author: {
        name: "Nathan Clarke",
        role: "Founder",
        company: "Phoenix, AZ, North America",
      },
    },
    {
      id: "t.03",
      rating: 5,
      quote:
        "While searching various software outsourcing companies, VelanApps stood out due to their transparent and systematic development process. We had highly detailed sprint reports every 2 weeks, weekly calls for constant communication.",
      result:
        "Launched our SaaS platform in 18 weeks — 22% under anticipated spend",
      author: {
        name: "Kevin Harrington",
        role: "VP Product",
        company: "Streamline SaaS Company · Atlanta, USA",
      },
    },
    {
      id: "t.04",
      rating: 5,
      quote:
        "VelanApps delivered end-to-end website development services — strategy, UX design, custom WordPress development, CRM integration, and SEO architecture. Their consultative approach stood out.",
      result:
        "47% rise in leads from organic sources in 90 days. Bounce rate dropped from 74% to 38%",
      author: {
        name: "Thomas Gallagher",
        role: "Director of Marketing",
        company: "Denver, CO, USA",
      },
    },
    {
      id: "enterprise.01",
      rating: 5,
      quote:
        "Velan Apps refactored our core platform into microservices in less than a day with no downtime. They delivered exactly what was scoped and significantly improved system reliability.",
      result: "99.95% Platform Uptime",
      author: {
        name: "Rachel Morgan",
        role: "Chief Information Officer",
        company: "Nexus Enterprises",
      },
    },
    {
      id: "enterprise.02",
      rating: 5,
      quote:
        "A trusted software development partner — security-first, transparent, and consistently on schedule throughout our 18-month transformation program.",
      result: "30% Reduction in Operating Costs",
      author: {
        name: "David Walker",
        role: "VP of Engineering",
        company: "ScaleOps Technologies",
      },
    },
    {
      id: "mvp.01",
      rating: 5,
      quote:
        "Velan Apps' custom MVP software development turned our concept into a working platform in under seven weeks.",
      result: "We closed our seed round two months later. ($1.2M seed)",
      author: { name: "Sona Rao", role: "Founder", company: "HealthStack" },
    },
    {
      id: "api.01",
      rating: 5,
      quote:
        "Velan Apps demystified a decade of point-to-point integrations and provided us with a single clean API layer. Our teams are finally confident in the information.",
      result: "60% Reduction in Integration Complexity",
      author: {
        name: "James Whitfield",
        role: "Chief Technology Officer",
        company: "Meridian FinTech",
      },
    },
    // Real store customer reviews carried over from the legacy store site
    // (see src/data/storeTestimonialsData.js). No rating/role was given in
    // the source, so neither is fabricated here — ClientReviews renders
    // around their absence, same as TestimonialsSection does.
    ...storeTestimonials.map((t) => ({
      id: t.id,
      quote: t.quote,
      author: { name: t.name, company: t.company, image: t.image },
    })),
  ],
};

export const ApplicationModernTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our Application",
    coloredText: "Modernization Services",
    description: null,
  },
  items: [
    {
      id: "rest.01",
      rating: 5,
      quote:
        "Velan Apps transformed a mess of old endpoints into a well-documented REST layer. Our integrations now work predictably — something we hadn't experienced in years.",
      result: "100% Predictable Integration Performance",
      author: {
        name: "Richard Hawes",
        role: "VP of Engineering",
        company: "CoreBridge Systems",
      },
    },
    {
      id: "rest.02",
      rating: 5,
      quote:
        "They built our public REST API and SDKs from the ground up. Partner onboarding that previously took weeks now takes a single day.",
      result: "Partner Onboarding Reduced from Weeks to 1 Day",
      author: {
        name: "Leila Fontaine",
        role: "Head of Platform",
        company: "Nexio SaaS",
      },
    },
    {
      id: "rest.03",
      rating: 5,
      quote:
        "Our CRM, billing, and analytics are now connected through a single REST API with webhooks. Manual data entry between systems is completely gone.",
      result: "Zero Manual Data Entry Across 3 Core Systems",
      author: {
        name: "Daniel Osei",
        role: "Director of Operations",
        company: "Vantage Commerce",
      },
    },

    ...testimonialsData.items,
  ],
};

export const GenAiTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our Gen AI",
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "rest.01",
      rating: 5,
      quote:
        "Velan Apps transformed a mess of old endpoints into a well-documented REST layer. Our integrations now work predictably — something we hadn't experienced in years.",
      result: "100% Predictable Integration Performance",
      author: {
        name: "Richard Hawes",
        role: "VP of Engineering",
        company: "CoreBridge Systems",
      },
    },
    {
      id: "rest.02",
      rating: 5,
      quote:
        "They built our public REST API and SDKs from the ground up. Partner onboarding that previously took weeks now takes a single day.",
      result: "Partner Onboarding Reduced from Weeks to 1 Day",
      author: {
        name: "Leila Fontaine",
        role: "Head of Platform",
        company: "Nexio SaaS",
      },
    },
    {
      id: "rest.03",
      rating: 5,
      quote:
        "Our CRM, billing, and analytics are now connected through a single REST API with webhooks. Manual data entry between systems is completely gone.",
      result: "Zero Manual Data Entry Across 3 Core Systems",
      author: {
        name: "Daniel Osei",
        role: "Director of Operations",
        company: "Vantage Commerce",
      },
    },

    ...testimonialsData.items,
  ],
};

export const AiChatbotTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our AI Chatbot",
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "rest.01",
      rating: 5,
      quote:
        "Velan Apps transformed a mess of old endpoints into a well-documented REST layer. Our integrations now work predictably — something we hadn't experienced in years.",
      result: "100% Predictable Integration Performance",
      author: {
        name: "Richard Hawes",
        role: "VP of Engineering",
        company: "CoreBridge Systems",
      },
    },
    {
      id: "rest.02",
      rating: 5,
      quote:
        "They built our public REST API and SDKs from the ground up. Partner onboarding that previously took weeks now takes a single day.",
      result: "Partner Onboarding Reduced from Weeks to 1 Day",
      author: {
        name: "Leila Fontaine",
        role: "Head of Platform",
        company: "Nexio SaaS",
      },
    },
    {
      id: "rest.03",
      rating: 5,
      quote:
        "Our CRM, billing, and analytics are now connected through a single REST API with webhooks. Manual data entry between systems is completely gone.",
      result: "Zero Manual Data Entry Across 3 Core Systems",
      author: {
        name: "Daniel Osei",
        role: "Director of Operations",
        company: "Vantage Commerce",
      },
    },

    ...testimonialsData.items,
  ],
};

export const AiIntegrationTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "Client",
    coloredText: "Testimonials",
    description: null,
  },
  items: [
    {
      id: "ai-integration.01",
      rating: 5,
      quote:
        "VelanApps helped us integrate AI capabilities into our existing healthcare software. Their team understood our workflow requirements and delivered a solution that improved process efficiency and reduced manual tasks.",
      result: null,
      author: {
        name: "Jordan Whitaker",
        role: "Healthcare Operations Director",
        company: "",
      },
    },
    {
      id: "ai-integration.02",
      rating: 5,
      quote:
        "We needed to integrate AI into our existing business applications without disrupting our operations. VelanApps provided a practical approach to AI integration, with a strong focus on system compatibility, scalability, and performance.",
      result: null,
      author: {
        name: "Melissa Hartwell",
        role: "Chief Technology Manager",
        company: "",
      },
    },
    {
      id: "ai-integration.03",
      rating: 5,
      quote:
        "VelanApps supported our AI integration project from planning to deployment. Their expertise in AI APIs, software integration, and workflow automation helped us introduce intelligent features into our existing systems.",
      result: null,
      author: {
        name: "Daniel Brooks",
        role: "Director of Digital Transformation",
        company: "",
      },
    },
  ],
};

export const RealEstateSoftwareDevelopmentTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our Real Estate Software",
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "realestate.01",
      rating: 5,
      quote:
        "The decision to work with VelanApps was a good one. Their experience in developing custom real estate software solutions that supported our property management platform helped us automate listings, tenant management, and reporting.",
      result: "Cut manual reporting time by 60% in the first quarter",
      author: {
        name: "Angela Brooks",
        role: "Director of Operations",
        company: "Harborview Property Management",
      },
    },
    {
      id: "realestate.02",
      rating: 5,
      quote:
        "Their team created an AI-powered real estate software platform for our property listing marketplace, which significantly enhanced search capabilities and customer interaction.",
      result:
        "35% increase in buyer engagement after launching AI-powered search",
      author: {
        name: "Marcus Delgado",
        role: "Head of Product",
        company: "Meridian Realty Group",
      },
    },
    {
      id: "realestate.03",
      rating: 5,
      quote:
        "VelanApps delivered an enterprise real estate app development solution for our brokerage, giving our agents a single dashboard to manage leads and property listings.",
      result:
        "Consolidated 4 separate tools into one dashboard, cutting agent onboarding time in half",
      author: {
        name: "Rachel Kim",
        role: "Managing Broker",
        company: "Bridgeway Realty Brokers",
      },
    },
    {
      id: "realestate.04",
      rating: 5,
      quote:
        "The team delivered scalable real estate property management software along with a real estate CRM, helping us run more efficient operations and cut down countless manual hours.",
      result:
        "Reduced administrative workload by 25+ hours per week across the team",
      author: {
        name: "David Park",
        role: "VP of Operations",
        company: "Coastline Property Partners",
      },
    },

    ...testimonialsData.items,
  ],
};

export const SoftwareMaintainTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our Software Maintenance",
    coloredText: "Services",
    description: null,
  },
  items: [
    {
      id: "softwaremaintain.01",
      rating: 5,
      quote:
        "Velan Apps took over maintenance of a fragile legacy platform and stabilized it within a month. Downtime is no longer a weekly conversation.",
      result: "Stabilized a fragile legacy platform within one month",
      author: {
        name: "Steven Cole",
        role: "Head of Engineering",
        company: "Brightline Logistics",
      },
    },
    {
      id: "softwaremaintain.02",
      rating: 5,
      quote:
        "They consistently beat our response and resolution SLAs, with clear monthly reporting we actually trust.",
      result: "Consistently beats response and resolution SLAs",
      author: {
        name: "Priya Nathan",
        role: "VP of Customer Success",
        company: "Fenwick Financial Services",
      },
    },
    {
      id: "softwaremaintain.03",
      rating: 5,
      quote:
        "Critical incidents dropped sharply after their preventive maintenance and monitoring kicked in.",
      result: "Sharp drop in critical incidents after preventive maintenance",
      author: {
        name: "Marcus Webb",
        role: "Director of IT Operations",
        company: "Alden Retail Group",
      },
    },
    {
      id: "softwaremaintain.04",
      rating: 5,
      quote:
        "Three years in, they still feel like our own team. Reliable, proactive, and easy to work with.",
      result: "3+ years of reliable, proactive long-term support",
      author: {
        name: "Laura Chen",
        role: "COO",
        company: "Northgate Health Systems",
      },
    },

    ...testimonialsData.items,
  ],
};

export const SwiftAppTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our Swift App",
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "softwaremaintain.01",
      rating: 5,
      quote:
        "Velan Apps took over maintenance of a fragile legacy platform and stabilized it within a month. Downtime is no longer a weekly conversation.",
      result: "Stabilized a fragile legacy platform within one month",
      author: {
        name: "Steven Cole",
        role: "Head of Engineering",
        company: "Brightline Logistics",
      },
    },
    {
      id: "softwaremaintain.02",
      rating: 5,
      quote:
        "They consistently beat our response and resolution SLAs, with clear monthly reporting we actually trust.",
      result: "Consistently beats response and resolution SLAs",
      author: {
        name: "Priya Nathan",
        role: "VP of Customer Success",
        company: "Fenwick Financial Services",
      },
    },
    {
      id: "softwaremaintain.03",
      rating: 5,
      quote:
        "Critical incidents dropped sharply after their preventive maintenance and monitoring kicked in.",
      result: "Sharp drop in critical incidents after preventive maintenance",
      author: {
        name: "Marcus Webb",
        role: "Director of IT Operations",
        company: "Alden Retail Group",
      },
    },
    {
      id: "softwaremaintain.04",
      rating: 5,
      quote:
        "Three years in, they still feel like our own team. Reliable, proactive, and easy to work with.",
      result: "3+ years of reliable, proactive long-term support",
      author: {
        name: "Laura Chen",
        role: "COO",
        company: "Northgate Health Systems",
      },
    },

    ...testimonialsData.items,
  ],
};

export const HybridAppTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our Hybrid App",
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "softwaremaintain.01",
      rating: 5,
      quote:
        "Velan Apps took over maintenance of a fragile legacy platform and stabilized it within a month. Downtime is no longer a weekly conversation.",
      result: "Stabilized a fragile legacy platform within one month",
      author: {
        name: "Steven Cole",
        role: "Head of Engineering",
        company: "Brightline Logistics",
      },
    },
    {
      id: "softwaremaintain.02",
      rating: 5,
      quote:
        "They consistently beat our response and resolution SLAs, with clear monthly reporting we actually trust.",
      result: "Consistently beats response and resolution SLAs",
      author: {
        name: "Priya Nathan",
        role: "VP of Customer Success",
        company: "Fenwick Financial Services",
      },
    },
    {
      id: "softwaremaintain.03",
      rating: 5,
      quote:
        "Critical incidents dropped sharply after their preventive maintenance and monitoring kicked in.",
      result: "Sharp drop in critical incidents after preventive maintenance",
      author: {
        name: "Marcus Webb",
        role: "Director of IT Operations",
        company: "Alden Retail Group",
      },
    },
    {
      id: "softwaremaintain.04",
      rating: 5,
      quote:
        "Three years in, they still feel like our own team. Reliable, proactive, and easy to work with.",
      result: "3+ years of reliable, proactive long-term support",
      author: {
        name: "Laura Chen",
        role: "COO",
        company: "Northgate Health Systems",
      },
    },

    ...testimonialsData.items,
  ],
};

export const MobileAppTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our Mobile App",
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "softwaremaintain.01",
      rating: 5,
      quote:
        "Velan Apps took over maintenance of a fragile legacy platform and stabilized it within a month. Downtime is no longer a weekly conversation.",
      result: "Stabilized a fragile legacy platform within one month",
      author: {
        name: "Steven Cole",
        role: "Head of Engineering",
        company: "Brightline Logistics",
      },
    },
    {
      id: "softwaremaintain.02",
      rating: 5,
      quote:
        "They consistently beat our response and resolution SLAs, with clear monthly reporting we actually trust.",
      result: "Consistently beats response and resolution SLAs",
      author: {
        name: "Priya Nathan",
        role: "VP of Customer Success",
        company: "Fenwick Financial Services",
      },
    },
    {
      id: "softwaremaintain.03",
      rating: 5,
      quote:
        "Critical incidents dropped sharply after their preventive maintenance and monitoring kicked in.",
      result: "Sharp drop in critical incidents after preventive maintenance",
      author: {
        name: "Marcus Webb",
        role: "Director of IT Operations",
        company: "Alden Retail Group",
      },
    },
    {
      id: "softwaremaintain.04",
      rating: 5,
      quote:
        "Three years in, they still feel like our own team. Reliable, proactive, and easy to work with.",
      result: "3+ years of reliable, proactive long-term support",
      author: {
        name: "Laura Chen",
        role: "COO",
        company: "Northgate Health Systems",
      },
    },

    ...testimonialsData.items,
  ],
};

export const MobileAppBackendTestimonialsData = {
  heading: {
    topText: "What Clients Say About",
    titleText: "Mobile App Backend",
    coloredText: "Development Services",
    description:
      "Verified reviews from founders who shipped their MVP with VelanApps and went on to raise funding.",
  },
  items: [
    {
      id: "mvp.01",
      rating: 5,
      quote:
        "Velan's Backend Developers helped our nascent app team scale a growing inventory of features into robust and reliable backend architecture. Velan team's worked across API design, database tuning and third-party integrations, always considering the performance aspects of our product with ease. Our future as a scalable tech product starts here.",
      result: "",
      author: {
        name: "Ethan Parker",
        role: "Product Director",
        company: "",
      },
    },
    {
      id: "mvp.02",
      rating: 5,
      quote:
        "We require multiple integrations with various external services to fuel our mobile app functionality. Keeping up with all of them proved difficult to sync. Our team relied on the expertise of Velan's developers to set up a lean API layer and to streamline the existing client to server logic, and the stability of the overall application improved significantly.",
      result: "",
      author: {
        name: "Olivia Reynolds",
        role: "Technology Manager",
        company: "",
      },
    },
    {
      id: "mvp.03",
      rating: 5,
      quote:
        "It was critical for our team that we had an app back-end capable of supporting high performing real time features without impacting security or performance, so our backend was rebuilt from the ground up to correspond to our needs. The infrastructure team paid extra attention to response time, authentic security and scalability of our system.",
      result: "",
      author: {
        name: "Marcus Bennett",
        role: "VP of Engineering",
        company: "",
      },
    },
  ],
};

export const AndroidAppTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our Android App",
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "androidApp.01",
      rating: 5,
      quote:
        "Velan Apps rebuilt our Android app in Kotlin and cut our crash rate to almost nothing. The Play Store rating jumped within weeks of the release.",
      result: "Crash rate cut to near zero after Kotlin rebuild",
      author: {
        name: "Rahul Menon",
        role: "Product Manager",
        company: "Fenwick Financial Services",
      },
    },
    {
      id: "androidApp.02",
      rating: 5,
      quote:
        "From Play Store compliance to submission, they handled the entire launch. Our app was approved on the first try with zero back-and-forth.",
      result: "First-attempt Google Play Store approval",
      author: {
        name: "Steven Cole",
        role: "Head of Engineering",
        company: "Brightline Logistics",
      },
    },
    {
      id: "androidApp.03",
      rating: 5,
      quote:
        "Their team scaled our Android app to handle 5x our original user base without a single major outage.",
      result: "Scaled to 5x user base with zero major outages",
      author: {
        name: "Marcus Webb",
        role: "Director of IT Operations",
        company: "Alden Retail Group",
      },
    },
    {
      id: "androidApp.04",
      rating: 5,
      quote:
        "Two years and multiple feature releases later, they still feel like an extension of our own product team.",
      result: "2+ years of ongoing feature delivery and support",
      author: {
        name: "Laura Chen",
        role: "COO",
        company: "Northgate Health Systems",
      },
    },

    ...testimonialsData.items,
  ],
};

export const AiAppTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our AI App",
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "softwaremaintain.01",
      rating: 5,
      quote:
        "Velan Apps took over maintenance of a fragile legacy platform and stabilized it within a month. Downtime is no longer a weekly conversation.",
      result: "Stabilized a fragile legacy platform within one month",
      author: {
        name: "Steven Cole",
        role: "Head of Engineering",
        company: "Brightline Logistics",
      },
    },
    {
      id: "softwaremaintain.02",
      rating: 5,
      quote:
        "They consistently beat our response and resolution SLAs, with clear monthly reporting we actually trust.",
      result: "Consistently beats response and resolution SLAs",
      author: {
        name: "Priya Nathan",
        role: "VP of Customer Success",
        company: "Fenwick Financial Services",
      },
    },
    {
      id: "softwaremaintain.03",
      rating: 5,
      quote:
        "Critical incidents dropped sharply after their preventive maintenance and monitoring kicked in.",
      result: "Sharp drop in critical incidents after preventive maintenance",
      author: {
        name: "Marcus Webb",
        role: "Director of IT Operations",
        company: "Alden Retail Group",
      },
    },
    {
      id: "softwaremaintain.04",
      rating: 5,
      quote:
        "Three years in, they still feel like our own team. Reliable, proactive, and easy to work with.",
      result: "3+ years of reliable, proactive long-term support",
      author: {
        name: "Laura Chen",
        role: "COO",
        company: "Northgate Health Systems",
      },
    },

    ...testimonialsData.items,
  ],
};

export const CustomAppTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our Custom App",
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "softwaremaintain.01",
      rating: 5,
      quote:
        "Velan Apps took over maintenance of a fragile legacy platform and stabilized it within a month. Downtime is no longer a weekly conversation.",
      result: "Stabilized a fragile legacy platform within one month",
      author: {
        name: "Steven Cole",
        role: "Head of Engineering",
        company: "Brightline Logistics",
      },
    },
    {
      id: "softwaremaintain.02",
      rating: 5,
      quote:
        "They consistently beat our response and resolution SLAs, with clear monthly reporting we actually trust.",
      result: "Consistently beats response and resolution SLAs",
      author: {
        name: "Priya Nathan",
        role: "VP of Customer Success",
        company: "Fenwick Financial Services",
      },
    },
    {
      id: "softwaremaintain.03",
      rating: 5,
      quote:
        "Critical incidents dropped sharply after their preventive maintenance and monitoring kicked in.",
      result: "Sharp drop in critical incidents after preventive maintenance",
      author: {
        name: "Marcus Webb",
        role: "Director of IT Operations",
        company: "Alden Retail Group",
      },
    },
    {
      id: "softwaremaintain.04",
      rating: 5,
      quote:
        "Three years in, they still feel like our own team. Reliable, proactive, and easy to work with.",
      result: "3+ years of reliable, proactive long-term support",
      author: {
        name: "Laura Chen",
        role: "COO",
        company: "Northgate Health Systems",
      },
    },

    ...testimonialsData.items,
  ],
};

export const iOSAppTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: (
      <span>
        About Our <span className="normal-case">iOS</span> App
      </span>
    ),
    coloredText: "Development Services",
    description: null,
  },
  items: [
    {
      id: "softwaremaintain.01",
      rating: 5,
      quote:
        "Velan Apps took over maintenance of a fragile legacy platform and stabilized it within a month. Downtime is no longer a weekly conversation.",
      result: "Stabilized a fragile legacy platform within one month",
      author: {
        name: "Steven Cole",
        role: "Head of Engineering",
        company: "Brightline Logistics",
      },
    },
    {
      id: "softwaremaintain.02",
      rating: 5,
      quote:
        "They consistently beat our response and resolution SLAs, with clear monthly reporting we actually trust.",
      result: "Consistently beats response and resolution SLAs",
      author: {
        name: "Priya Nathan",
        role: "VP of Customer Success",
        company: "Fenwick Financial Services",
      },
    },
    {
      id: "softwaremaintain.03",
      rating: 5,
      quote:
        "Critical incidents dropped sharply after their preventive maintenance and monitoring kicked in.",
      result: "Sharp drop in critical incidents after preventive maintenance",
      author: {
        name: "Marcus Webb",
        role: "Director of IT Operations",
        company: "Alden Retail Group",
      },
    },
    {
      id: "softwaremaintain.04",
      rating: 5,
      quote:
        "Three years in, they still feel like our own team. Reliable, proactive, and easy to work with.",
      result: "3+ years of reliable, proactive long-term support",
      author: {
        name: "Laura Chen",
        role: "COO",
        company: "Northgate Health Systems",
      },
    },

    ...testimonialsData.items,
  ],
};

export const CustomEcommerceTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our Custom",
    coloredText: "eCommerce Development",
    description: null,
  },
  items: [
    {
      id: "customecommerce.01",
      rating: 5,
      quote:
        "They recognised that our business required more than an online shop. They crafted special workflows and integrations based on how we operate, making the ordering process significantly easier for our customers and staff.",
      result: "",
      author: {
        name: "Wesley Rourke",
        role: "Director of Digital Commerce",
        company: "",
      },
    },
    {
      id: "customecommerce.02",
      rating: 5,
      quote:
        "When our product catalogue and customer base expanded, our previous platform was no longer scalable. Velan Apps offered a scalable eCommerce platform for us to grow into, with a more seamless purchase experience, higher performance and more flexible technology.",
      result: "",
      author: {
        name: "Blaine Mercer",
        role: "VP of eCommerce",
        company: "",
      },
    },
    {
      id: "customecommerce.03",
      rating: 5,
      quote:
        "The greatest differentiator was how seamlessly the platform fit into our actual way of doing business, from pricing for specific customers to third-party integrations, Velan Apps delivered the complex to a usable, manageable eCommerce.",
      result: "",
      author: {
        name: "Callahan Prescott",
        role: "Chief Technology Officer",
        company: "",
      },
    },
  ],
};

export const MagentoDevelopmentTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our",
    coloredText: "Magento Development",
    description: null,
  },
  items: [
    {
      id: "magentoDevelopment.01",
      rating: 5,
      quote:
        "Velan Apps studied our catalogue, customers and internal processes before they built the website. The Magento store they built for us was unique to our requirements - not just a standard set-up. Everything was professional and well organised.",
      result: "",
      author: {
        name: "Harvey",
        role: "VP of Digital Commerce",
        company: "",
      },
    },
    {
      id: "magentoDevelopment.02",
      rating: 5,
      quote:
        "Our Magento eCommerce project had several integrations with inventory, CRM, payments, and shipping and it was really complex technically. Velan Apps stayed on top of that while making our communication smooth. Our eCommerce has become more integrated and manageable.",
      result: "",
      author: {
        name: "Louis Pearson",
        role: "Director of eCommerce",
        company: "",
      },
    },
    {
      id: "magentoDevelopment.03",
      rating: 5,
      quote:
        "The integrations in our Magento project between inventory, CRM, payments, and shipping are very extensive. Velan Apps efficiently managed the technical details and maintained excellent communication. Our eCommerce business has become more synchronized and manageable.",
      result: "",
      author: {
        name: "Mike Ross",
        role: "Head of Digital Operations",
        company: "",
      },
    },
  ],
};

export const WoocommerceDevelopmentTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our",
    coloredText: "WooCommerce Development",
    description: null,
  },
  items: [
    {
      id: "woocommerceDevelopment.01",
      rating: 5,
      quote:
        "The Velan Apps team understood our business needs and was able to develop a Woo Commerce online store that just looks great with a total matching theme. Our customers can browse and shop a lot easier and our team can manage products and orders quickly.",
      result: "",
      author: {
        name: "Olivia Parker",
        role: "Founder & CEO",
        company: "Retail Brand",
      },
    },
    {
      id: "woocommerceDevelopment.02",
      rating: 5,
      quote:
        "Velan Apps created an easier and quicker way to shop. Our ecommerce store is now more convenient for the customer and our team. Velan Apps took care of the technical side of our online store by paying attention to the responsive design, website speed and checkout process.",
      result: "",
      author: {
        name: "Madeline Foster",
        role: "Director of eCommerce",
        company: "Consumer Goods Company",
      },
    },
    {
      id: "woocommerceDevelopment.03",
      rating: 5,
      quote:
        "Velan Apps helped us integrate our Woo Commerce store with other business applications. Their team understood our needs, communicated efficiently, and devised a solution to ease our daily eCommerce tasks.",
      result: "",
      author: {
        name: "Bennett Hayes",
        role: "Operations Manager",
        company: "Online Wholesale Business",
      },
    },
  ],
};

export const ThirdPartyApiDevelopmentTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our",
    coloredText: "Third-Party Integration",
    description: null,
  },
  items: [
    {
      id: "thirdPartyApiDevelopment.01",
      rating: 5,
      quote:
        "Velan Apps brought our CRM, payment platform, and internal systems together to create a simple integrated process. By connecting these systems and automating the data flow, we eliminated a lot of manual work, and our staff now have much more accurate access to customer and purchase information.",
      result: "",
      author: {
        name: "Ethan Caldwell",
        role: "Chief Technology Officer",
        company: "",
      },
    },
    {
      id: "thirdPartyApiDevelopment.02",
      rating: 5,
      quote:
        "We had multiple, unconnected business applications which made managing orders and stocks more complex than it needed to be. Velan Apps developed the integrations we needed, which created a much smoother flow of information between our eCommerce and back-end systems.",
      result: "",
      author: {
        name: "Claire Montgomery",
        role: "VP of Digital Operations",
        company: "",
      },
    },
    {
      id: "thirdPartyApiDevelopment.03",
      rating: 5,
      quote:
        "Velan Apps understood exactly what we were after and left no stone unturned in delivering our integration. Our systems now share data seamlessly, and our staff are wasting far less time on repetitive manual data processing.",
      result: "",
      author: {
        name: "Ross Geller",
        role: "Operations Director",
        company: "",
      },
    },
  ],
};

export const StoreTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "Trusted by Businesses",
    coloredText: "Running on Our Extensions",
    description: null,
  },
  items: storeTestimonials.map((t) => ({
    id: t.id,
    quote: t.quote,
    author: { name: t.name, company: t.company, image: t.image },
  })),
};

// UI/UX Design
export const UiUxDesignTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our",
    coloredText: "UI/UX Design Services",
    description: null,
  },
  items: [
    {
      id: "uiuxdesign.01",
      rating: 5,
      quote:
        "Velan Apps provided insight and attention to detail in our product experience, with a sleek interface. The new look and feel is more consistent and intuitive, and significantly easier for our users to use.",
      result: "",
      author: {
        name: "Bennett Lawson",
        role: "Product Strategy Director",
        company: "",
      },
    },
    {
      id: "uiuxdesign.02",
      rating: 5,
      quote:
        "The team understood what we wanted to achieve and created a sleek and engaging experience for our website. The focus they paid to the details of the user journey and interface has really benefited our product.",
      result: "",
      author: {
        name: "Avery Sullivan",
        role: "Head of Digital Products",
        company: "",
      },
    },
    {
      id: "uiuxdesign.03",
      rating: 5,
      quote:
        "Velan Apps gave us a fresh way of thinking about how users engage with our offering. The new UI is slick, strong, and totally in line with how our customers interact with the product.",
      result: "",
      author: {
        name: "Colton Hayes",
        role: "VP of Product & Innovation",
        company: "",
      },
    },
  ],
};

export const UiDesignTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our",
    coloredText: "UI Design Services",
    description: null,
  },
  items: [
    {
      id: "uiuxdesign.01",
      rating: 5,
      quote:
        "Velan Apps developed a sophisticated, clear, and clean user interface that is easy to use. Designed to suit our needs, Velan's product designers realized our end product and by doing so maintained usability.",
      result: "",
      author: {
        name: "Connor Hayes",
        role: "Senior Product Manager",
        company: "",
      },
    },
    {
      id: "uiuxdesign.02",
      rating: 5,
      quote:
        "Velan Apps' team created a cohesive and careful UI throughout our prototype from early concepts to the finished Velan Apps. The interface they produced gave our product an extremely professional online appearance.",
      result: "",
      author: {
        name: "Avery Morgan",
        role: "Head of Digital Experience",
        company: "",
      },
    },
    {
      id: "uiuxdesign.03",
      rating: 5,
      quote:
        "Our platform had a bunch of complicated workflows, Velan Apps simplified them into a clean and user-friendly user interface. Our new user interface allows our users to navigate through the platform more easily and perform tasks.",
      result: "",
      author: {
        name: "Gunther Geller",
        role: "Director of Product",
        company: "",
      },
    },
  ],
};

export const UxDesignTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our",
    coloredText: "UX Design Services",
    description: null,
  },
  items: [
    {
      id: "uiuxdesign.01",
      rating: 5,
      quote:
        "Velan Apps really made what was a complicated user journey a lot simpler and more user-friendly. Their UX design team made our platform much more intuitive and user-friendly, and thus engaging, to our customers.",
      result: "",
      author: {
        name: "Allison Mercer",
        role: "Product Experience Manager",
        company: "",
      },
    },
    {
      id: "uiuxdesign.02",
      rating: 5,
      quote:
        "Our team at Velan Apps knew exactly who our users were and what they wanted from the beginning. Their usability research, wireframes and streamlining touch made the digital experience a lot better.",
      result: "",
      author: {
        name: "Ryan Holloway",
        role: "Director of Digital Products",
        company: "",
      },
    },
    {
      id: "uiuxdesign.03",
      rating: 5,
      quote:
        "Working with Velan Apps gave our product a well-guided UX. They distilled complex flows into straightforward interactions that enhanced the user experience of our product.",
      result: "",
      author: {
        name: "Brooke Harrison",
        role: "VP of Product Strategy",
        company: "",
      },
    },
  ],
};

export const WebsiteRedesignTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our",
    coloredText: "Website Redesign",
    description: null,
  },
  items: [
    {
      id: "websiteredesign.01",
      rating: 5,
      quote:
        "VelanApps transformed our outdated website into a modern, intuitive experience that feels aligned with our brand. The improved navigation and cleaner interface have made it much easier for our customers to engage with us.",
      result: "",
      author: {
        name: "Callum Whitaker",
        role: "VP of Digital Strategy ",
        company: "",
      },
    },
    {
      id: "websiteredesign.02",
      rating: 5,
      quote:
        "The redesign gave our website a completely new direction without losing what made our brand recognizable. The new structure, responsive experience, and streamlined user journey have made a noticeable difference.",
      result: "",
      author: {
        name: "Brielle Kensington",
        role: "Director of Marketing",
        company: "",
      },
    },
    {
      id: "websiteredesign.03",
      rating: 5,
      quote:
        "VelanApps approached our redesign with both creativity and strategy. They simplified complex navigation, refreshed the visual experience, and delivered a website that feels significantly more professional and engaging.",
      result: "",
      author: {
        name: "Everett Callahan",
        role: "Chief Growth Officer",
        company: "",
      },
    },
  ],
};

export const ResponsiveWebDesignTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our",
    coloredText: "Responsive Web Design",
    description: null,
  },
  items: [
    {
      id: "responsivewebdesign.01",
      rating: 5,
      quote:
        "Velan Apps made our website three different services like mobile, tablet and desktop. The new website, is in the global scope, faster, easier to navigate, and more engaging for our customers.",
      result: "",
      author: {
        name: "Phoebe Brooks",
        role: "Digital Marketing Director",
        company: "",
      },
    },
    {
      id: "responsivewebdesign.02",
      rating: 5,
      quote:
        "The old site looked very nice on desktop, but was challenging to navigate on mobile. Velan Apps re-designed the experience with a mobile-first approach which created a much more streamlined, consistent experience.",
      result: "",
      author: {
        name: "Derek Sullivan",
        role: "Head of Product",
        company: "",
      },
    },
    {
      id: "responsivewebdesign.03",
      rating: 5,
      quote:
        "The Velan Apps team created a beautifully designed, responsive website that functions perfectly across devices while maintaining our branding and performance. Their focus on performance and usability really shone through.",
      result: "",
      author: {
        name: "Monica Callahan",
        role: "Director of Web Strategy",
        company: "",
      },
    },
  ],
};

export const EcommerceWebsiteDevelopmentTestimonialsData = {
  heading: {
    topText: "Testimonials",
    titleText: "What Clients Say About Our",
    coloredText: (
      <>
        <span className="normal-case">eCommerce</span> Website Development
      </>
    ),
    description: null,
  },
  items: [
    {
      id: "ecommercewebsitedevelopment.01",
      rating: 5,
      quote:
        "VelanApps helped us to create a progressive website, which looks attractive on smartphones, tablets, and laptops. The interface is intuitive and easy to navigate, which increases the likelihood that our clients will choose our company over our competitors.",
      result: "",
      author: {
        name: "Lauren Whitmore",
        role: "Marketing Director",
        company: "",
      },
    },
    {
      id: "ecommercewebsitedevelopment.02",
      rating: 5,
      quote:
        "The website has a modern design and is responsive on all devices, which makes it easier for our customers to perceive the brand and use its services. VelanApps team fully understood our requirements and developed a website that meets the highest standards of web design",
      result: "",
      author: {
        name: "Preston Callahan",
        role: "Chief Operating Officer",
        company: "",
      },
    },
    {
      id: "ecommercewebsitedevelopment.03",
      rating: 5,
      quote:
        "VelanApps has done a great job and provided us with an easily customizable design that looks good on all devices. The responsive design approach allows us to offer our services to clients with different digital environments. We are extremely satisfied with the scope of work and collaboration with the team because they provided exceptional support throughout the development cycle.",
      result: "",
      author: {
        name: "Brielle Kensington",
        role: "Founder & CEO",
        company: "",
      },
    },
  ],
};

export const ApplicationTestingTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our",
    coloredText: "Application Testing Services",
    description: null,
  },
  items: [
    {
      id: "applicationtesting.01",
      rating: 5,
      quote:
        "VelanApps helped us discover issues with our application and ensured the reliability of the software before its release. Their work gave our team confidence in the quality of the product and a repeatable process for consistent user experiences.",
      result: "",
      author: {
        name: "Madison Reynolds",
        role: "Director of Software Engineering",
        company: "",
      },
    },
    {
      id: "applicationtesting.02",
      rating: 5,
      quote:
        "The VelanApps team helped us make our testing process more systematic and automated, allowing us to track and resolve defects more efficiently while improving our overall release process.",
      result: "",
      author: {
        name: "Ethan Sullivan",
        role: "QA Engineering Manager",
        company: "",
      },
    },
    {
      id: "applicationtesting.03",
      rating: 5,
      quote:
        "Working with VelanApps gave a comprehensive testing process on our application to find any issues with our software’s performance, functionality, and security, giving us confidence in our product ahead of the launch.",
      result: "",
      author: {
        name: "Chloe Bennett",
        role: "Chief Technology Officer",
        company: "",
      },
    },
  ],
};

export const AutomationTestingTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our",
    coloredText: "Automation Testing Services",
    description: null,
  },

  items: [
    {
      id: "applicationtesting.01",
      rating: 5,
      quote:
        "VelanApps has contributed to our software testing process by providing excellent automation frameworks. We managed to eliminate several repetitive tests in our system and achieve high coverage of application features under test.",
      result: "",
      author: {
        name: "Christopher Hayes",
        role: "Director of Quality Assurance",
        company: "Software Technology Company",
      },
    },
    {
      id: "applicationtesting.02",
      rating: 5,
      quote:
        "The automation testing team has implemented a convenient regression testing cycle and CI/CD practices. This outcome has allowed us to increase the level of confidence in our software and detect more issues during the development process.",
      result: "",
      author: {
        name: "Rebecca Collins",
        role: "VP of Engineering",
        company: "SaaS Company",
      },
    },
    {
      id: "applicationtesting.03",
      rating: 5,
      quote:
        "We required automated tests for websites and API endpoints using different browsers. The team provided well-structured frameworks meeting all the requirements for effective maintenance and implementation in the development environment.",
      result: "",
      author: {
        name: "Matthew Sullivan",
        role: "QA Engineering Manager",
        company: "Enterprise Software Company",
      },
    },
  ],
};

export const complianceTestingTestimonialsData = {
  heading: {
    topText: "What Clients Say",
    titleText: "About Our",
    coloredText: "Compliance Testing Services",
    description: null,
  },
  items: [
    {
      id: "compliancetesting.01",
      rating: 5,
      quote:
        "Velan Apps uncovered compliance issues and enhanced our testing. Velaan Apps' methodical approach to meeting regulations provided us with increased insight into risk and better readiness for audits.",
      result: "",
      author: {
        name: "Ryan Mitchell",
        role: "Chief Compliance Officer",
        company: "",
      },
    },
    {
      id: "compliancetesting.02",
      rating: 5,
      quote:
        "The team was very comprehensive in validating the strength of our security controls and data protection practices. Their suggestions assisted us in remedying deficiencies and strengthened our readiness for compliance in key applications.",
      result: "",
      author: {
        name: "Ashley Cooper",
        role: "Director of Quality Assurance",
        company: "",
      },
    },
    {
      id: "compliancetesting.03",
      rating: 5,
      quote:
        "Velan Apps helped us understand our compliance needs and advised us on what to do first. Their in-depth reporting means we can monitor the problems we're having and test equally.",
      result: "",
      author: {
        name: "Brandon Foster",
        role: "Chief Information Security Officer",
        company: "",
      },
    },
  ],
};
